module.exports = __webpack_public_path__ + "static/media/benz-2.1400414e.jpg";